export const API_SUCCESS_STATUS_CODE = 1;
